@if (isMobile && !isExternalPatient) {
  <!--when in health plan, root, or my-health-->
  @if (isMyHealthPlan || (isMainMenu && !isActivityReport && hasActivePlan) || (isMyHealth && hasActivePlan)) {
    <button (click)="openSubMenu()" [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && (isMyHealthPlan || isMainMenu || isMyHealth)}"
      class="main-button"
      mat-fab>
      <mat-icon [ngClass]="{'rotate-close' : isSubMenuOpen, 'rotate-zero' : !isSubMenuOpen}" class="icon-color">add
      </mat-icon>
    </button>
  }
  <!--when in health plan activity new-->
  @if (isActivityReport && hasActivePlan) {
    <button (click)="saveAndGoBack()" [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isActivityReport}"
      class="main-button fab-save-button" mat-fab>
    <span class="fab-save-label">{{ 'healthPlan.save' | translate }}</span>
    </button>
  }
  <!--when in diary -->
  @if (isMyDiary) {
    <button (click)="goToLocation('/new')"
      [attr.aria-label]="'diary.addNewMeasurement' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isMyDiary}"
      class="main-button yellow-outline"
      mat-fab>
      <mat-icon class="icon-color">add</mat-icon>
    </button>
  }
} @else if (!isExternalPatient) {
  <!--when in health plan, root, or my-health-->
  @if (isMyHealthPlan || (isMainMenu && !isActivityReport && hasActivePlan) || (isMyHealth && hasActivePlan)) {
    <button
      (click)="openSubMenu()"
      [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [matTooltip]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && (isMyHealthPlan || isMainMenu || isMyHealth)}"
      class="desktop-main-button"
      mat-fab>
      <mat-icon [ngClass]="{'rotate-close' : isSubMenuOpen, 'rotate-zero' : !isSubMenuOpen}"
        class="icon-color">add
      </mat-icon>
    </button>
  }
  <!--when in health plan activity new-->
  @if (isActivityReport && hasActivePlan) {
    <button (click)="saveAndGoBack()"
      [attr.aria-label]="'healthPlan.youCanAddMeasurements' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isActivityReport}"
      class="desktop-main-button fab-save-button"
      mat-fab>
      <span class="fab-save-label">{{ 'healthPlan.save' | translate }}</span>
    </button>
  }
  <!--when in diary -->
  @if (isMyDiary) {
    <button
      (click)="goToLocation('/new')"
      [attr.aria-label]="'diary.addNewMeasurement' | translate"
      [matTooltip]="'diary.addNewMeasurement' | translate"
      [ngClass]="{'fab-container-hide' : !isVisible, 'fab-container-show' : isVisible && isMyDiary}"
      class="desktop-main-button yellow-outline"
      mat-fab>
      <mat-icon class="icon-color">add</mat-icon>
    </button>
  }
}




